import { Droppable } from "@/components/dnd/Droppable";
import { SortableRect } from "@/components/DeckBuilder/SortableRect";

export default function Deck({
  getCount,
  handleOpen,
  setHoveredAACardId,
}: {
  getCount: any;
  handleOpen: any;
  setHoveredAACardId: any;
}) {
  return (
    <Droppable id="display-deck">
      <div
        className="overflow-scroll"
        style={{
          height: "calc(100svh - 88px - 44px - 8px - 8px)",
          minHeight: "120px",
        }}
      >
        {/* <div className="flex flex-col gap-2 justify-center items-center"> */}
        {getCount() === 0 ? (
          <div className="h-full w-full flex justify-center items-center italic">
            No cards in deck
          </div>
        ) : (
          <div className="">
            <div className="flex flex-wrap gap-3 p-4 justify-center">
              <SortableRect
                handleOpen={handleOpen}
                setHoveredAACardId={setHoveredAACardId}
                disableClick={true}
              />
            </div>
          </div>
        )}
      </div>
    </Droppable>
  );
}
